import { Fragment, useCallback, useMemo, useRef, useState } from 'react';
import { stylesheet } from 'typestyle';
import classnames from 'classnames';

import css from '@styles/catalogFilters';

const qmCss = stylesheet({
  icon: {
    display: 'block',
    lineHeight: 0,
    cursor: 'pointer',
    height: 13,

    position: 'absolute',
    right: 9,
    top: 7
  }
});

function FilterCheckItem({
  label,
  image,
  imageAlt,
  imageWidth,
  popup: Popup,
  inputValue,
  onChange,
  selected,
  htmlId,
  className,
  ElementType = 'li'
}) {
  const questionMarkRef = useRef();
  const styles = useMemo(() => {
    const styleObj = {};

    if (typeof imageWidth !== 'undefined') {
      styleObj.width = imageWidth;
      styleObj.height = 'auto';
    }

    return styleObj;
  }, [imageWidth]);

  return (
    <ElementType className={className}>
      <input
        type='checkbox'
        value={inputValue}
        checked={selected}
        onChange={onChange}
        id={htmlId}
      />

      <label
        htmlFor={htmlId}
        className={classnames(css.filterLabel, {
          [css.checkedFilterLabel]: selected
        })}
        dangerouslySetInnerHTML={{ __html: label }}
      />

      {Popup ? (
        <Popup className={qmCss.icon} />
      ) : (
        <img
          src={image}
          alt={imageAlt}
          className={css.filterLabelImage}
          style={styles}
        />
      )}
    </ElementType>
  );
}

export default FilterCheckItem;
